export enum Source {
    partner = 'partner',
    dmn = 'dmn',
    designmynight = 'designmynight'
}


// WEBPACK FOOTER //
// ./src/models/Source.ts